import { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Select from '../atom/Select';
import { AccessoryDetailProps } from '../../models';
import type { IState } from '../../../../models';
import { getConnectionHandId } from '../../helpers/data/bot';

const DrainPanDetails = ({
  accessory,
  onSectionFieldChange,
  tunnelIndex,
  airflow_direction_id,
  tunnel_configuration,
}: AccessoryDetailProps) => {
  const { conn_hands } = useSelector((state: IState) => state.coil);
  const [isConnHandEnabled, setIsConnHandEnabled] = useState(false);

  const handleFieldChange = (value: string | number | null, name: string) => {
    if (onSectionFieldChange) {
      onSectionFieldChange(value, name);
    }
  };

  useEffect(() => {
    const data = getConnectionHandId(
      tunnel_configuration,
      tunnelIndex,
      airflow_direction_id,
    );
    setIsConnHandEnabled(data.enable);
    if (!data.enable) {
      handleFieldChange(data.value, 'conn_hand_id');
    }
  }, [tunnel_configuration, airflow_direction_id]);

  return (
    <div className="bot-accessories__detail-card">
      <div className="bot-accessories__detail-title">Drain Pan</div>
      <div className="bot-accessories__detail-grid">
        <div className="bot-accessories__detail-row">
          <span className="bot-accessories__detail-label">Connection Hand</span>
          <Select
            name="drain_conn_hand_id"
            options={conn_hands}
            value={accessory?.conn_hand_id ?? 2}
            onChange={handleFieldChange}
            className="bot-accessories__detail-select"
            border_bottom={false}
            disabled={!isConnHandEnabled}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(DrainPanDetails);
